import * as Sentry from '@sentry/react';

let initialized = false;
let warned = false;

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) {
    if (!warned) {
      // eslint-disable-next-line no-console
      console.warn('[observability] VITE_SENTRY_DSN unset — Sentry disabled');
      warned = true;
    }
    return;
  }
  if (initialized) return;
  Sentry.init({
    dsn,
    environment: (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) ?? 'development',
    tracesSampleRate: 0,
    // No replay either — spec calls for errors only.
    integrations: [],
  });
  initialized = true;
}

export { Sentry };
